/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_Export_CsvInputs */



/**
* | output |
* | --- |
* | "Export (CSV)" |
*
* @param {User_List_Export_CsvInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_export_csv = /** @type {((inputs?: User_List_Export_CsvInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Export_CsvInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter (CSV)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar (CSV)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Exportar (CSV)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta (CSV)")
	return /** @type {LocalizedString} */ ("Export (CSV)")
});